/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "abf8c512de88e216a3ffc12940e7f1a4175517c4";
